import { useAppSelector } from '../../../common/redux/hooks';
import CenteredContainer from '../../../components/layout/CenteredContainer';
import BottomButtonNavigation from '../../../navigation/BottomButtonNavigation';
import ServiceArea from '../TradesAndServicesPage/ServiceArea/ServiceArea';
import TradesAndServices from '../TradesAndServicesPage/TradesAndServices';

interface LaborInformationProps {
    handleBackClick: () => void;
    handleNextClick: () => void;
}

const LaborInformation = ({
    handleBackClick,
    handleNextClick,
}: LaborInformationProps) => {
    const teamInfo = useAppSelector(
        ({ contractorRegistration }) =>
            contractorRegistration.contractor.teamInfo
    );
    const trades = useAppSelector(
        ({ contractorRegistration }) => contractorRegistration.contractor.trades
    );
    const serviceArea = useAppSelector(
        ({ contractorRegistration }) =>
            contractorRegistration.contractor.serviceArea
    );

    const {
        commercialServiceProvider,
        singleFamilyServiceProvider,
        multiDwellingServiceProvider,
    } = teamInfo;

    const serviceProviderSelected =
        commercialServiceProvider ||
        singleFamilyServiceProvider ||
        multiDwellingServiceProvider;

    const isDisabled =
        !trades.length || !serviceProviderSelected || !serviceArea;

    return (
        <CenteredContainer>
            <TradesAndServices />
            <br />
            <ServiceArea />
            <BottomButtonNavigation
                onBackClick={handleBackClick}
                onNextClick={handleNextClick}
                nextDisabled={isDisabled}
            />
        </CenteredContainer>
    );
};

export default LaborInformation;
